<template>
  <v-card class="pa-4">
    <h3 class="font-weight-600 ml-2 mb-4">Проекты HR</h3>
    <AskDialog v-model="showAskDeleteDialog" @ok="onDelProject(curProject)" />
    <v-btn @click="$router.push('/ai/hrproject-edit/0') " class="mb-4" color="primary">
      Добавить проект
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="id"
      sort-desc
      :loading="loading.load"
      loading-text="Загрузка... Пожалуйста подождите"
      :mobile-breakpoint="300"
      :page="filter.page"
      :items-per-page="filter.pageSize"
      :height="tableHeight"
      fixed-header
      dense
      @pagination="pagination"
      hide-default-footer
      :server-items-length="count"
      :_footer-props="{ itemsPerPageOptions: [25] }"
    >
      <!-- Header -->
      <template v-slot:header>
        <tr>
          <!-- <td class="border-bottom pa-4">
            <div>
              <v-checkbox :input-value="selected.length" @change="onChangeAllCheck"
                :indeterminate="!!selected.length && selected.length !== count" hide-details class="mt-auto" dense
              />
            </div>
          </td> -->
          <td class="border-bottom pa-3">
              <v-text-field
                label="Название проекта" append-icon="mdi-magnify" class="font-sm" :value="filter.name"
                @input="debouncedSetFilterName" dense hide-details outlined
              />
          </td>

          <td class="border-bottom pa-3">
            <v-menu v-model="datePickerShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="filterRange.join(' - ')"
                  label="Продолжительность проекта"
                  append-icon="mdi-calendar"
                  :prepend-inner-icon="filterRange.length ? 'mdi-close' : null"
                  @click:prepend-inner="clearFilterRange"
                  class="font-sm"
                  dense readonly outlined hide-details
                  v-bind="attrs" v-on="on"
                />
              </template>

              <v-date-picker v-model="filterRange" dense range no-title scrollable locale="ru-RU">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelFilterRange"> Отменить </v-btn>
                <v-btn text color="primary" @click="applyFilterRange" :disabled="filterRange.length !== 2"> OK </v-btn>
              </v-date-picker>
            </v-menu>
          </td>

          <td class="border-bottom pa-3">
              <v-menu offset-y :close-on-content-click="false" ref="menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn elevation="0" class="font-weight-regular" v-bind="attrs" v-on="on" outlined color="grey darken-1">
                    Статус проекта {{selectedProjectStatuses.length ? `(${selectedProjectStatuses.split(',').length})` : ''}}
                    <v-icon v-if="attrs['aria-expanded']">mdi-menu-down</v-icon>
                    <v-icon v-else>mdi-menu-up</v-icon>
                  </v-btn>
                </template>
                <ListDocTypes v-model="selectedProjectStatuses" :items="projectStatuses" :loading="loading.load" @apply="loadItems">
                </ListDocTypes>
              </v-menu>
          </td>

          <td class="border-bottom pa-3"></td>
          <td class="border-bottom pa-3"></td>

          <td class="border-bottom pa-3">
            <div>
              <v-text-field label="Комментарий" append-icon="mdi-magnify" class="font-sm" dense :value="filter.comment"
                @input="debouncedSetFilterComment" hide-details outlined
              />
            </div>
          </td>
        </tr>
      </template>

      <!--  Cells  -->
      <!-- <template v-slot:item.check="{ item }">
        <div>
          <v-checkbox :input-value="selected.some(id => id === item.id)" @change="setSelected(item.id)" hide-details class="mt-auto" />
        </div>
      </template> -->

      <template v-slot:item.name="{ item }">
        <div class="d-flex justify-space-between align-center cursor-pointer" @click="$router.push(`/ai/hrproject-edit/${item.id}`)" >
          {{ item.name }}
        </div>
      </template>

      <template v-slot:item.range="{ item }">
        <div class="d-flex justify-space-between align-center">
          {{ $moment(item.date_from).format('DD.MM.YYYY') }} - {{ $moment(item.date_to).format('DD.MM.YYYY') }}
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <ProjectStatusIndicator :project="item" />
      </template>

      <template v-slot:item.expert="{ item }">
        <v-btn :outlined="!item.ai_result" color="primary" dense class="px-4 py-0 btn-view-analysis"  @click="$router.push(`/ai/hrproject-view/${item.id}`)">
          {{ item.ai_result ? 'Посмотреть анализ' : 'Провести анализ' }}
        </v-btn>
      </template>
      <template v-slot:item.vacancies="{ item }">
        <div>{{ item.vacancies }}</div>
      </template>

      <template v-slot:item.comment="{ item }">
        <div class="py-2 _pa-2 _other-width-col">
          <v-tooltip v-if="item.comment" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex" v-bind="attrs" v-on="on">
                <v-text-field label="Комментарий" class="font-xs" dense :value="item.comment" @input="debouncedSendComment($event, item)" hide-details outlined />
              </div>
            </template>
            <span>{{ item.comment }}</span>
          </v-tooltip>
          <v-text-field v-else label="Комментарий" class="font-xs" dense :value="item.comment" @input="debouncedSendComment($event, item)" hide-details outlined />
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn dense icon @click="$router.push(`/ai/hrproject-edit/${item.id}`)"><img src="@/assets/images/profile/arrowGo.svg" /></v-btn>
        <v-btn v-if="$store.getters['auth/isAllowed']('candidate_dossier_delete')"
          @click="deleteProjectDialog(item)" class="" dense icon :loading="loading.delProject===item.id"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data> Документов не найдено. </template>

      <template v-slot:footer="{ props }">
        <v-data-footer
          :pagination="props.pagination"
          :options="props.options"
          @update:options="updateOptions"
          items-per-page-text="Проектов на странице:"
          :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
          :page-text="`Всего проектов: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
          show-current-page
          show-first-last-page
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { PROJECT_STATUS_TITLES, PROJECT_STATUSES } from '@/common/constants/projectStatuses';
import ListDocTypes from '@/components/candidates/profile/dossier/ListDocTypes';
import AskDialog from "@/components/ui/AskDialog"
import ProjectStatusIndicator from "./ProjectStatusIndicator"

export default {
  name: 'AIProjectTable',
  components: {
    ListDocTypes, AskDialog, ProjectStatusIndicator
  },
  data: () => ({
    showAddDialog: false,
    showAskDeleteDialog: false,
    tableHeight: 400,
    projectStatuses: Object.entries(PROJECT_STATUS_TITLES).map(s => ({
      text: s[1],
      value: PROJECT_STATUSES[s[0]]
    })),
    headers: [
      // { text: '', value: 'check', sortable: false, width: '40px' },
      { text: 'Название проекта', value: 'name', sortable: false, width: '400px'  },
      { text: 'Продолжительность проекта', value: 'range', sortable: false, width: '240px' },
      { text: 'Статус проекта', value: 'status', sortable: false, width: '200px' },
      { text: 'Анализ от AI-эксперта', value: 'expert', sortable: false, width: '230px', },
      { text: 'Количество вакансий/ закрыто', value: 'vacancies', sortable: false, width: '130px', },
      { value: 'comment', sortable: false, width: '200px', text: 'Комментарий', },
      { text: '', value: 'actions', sortable: false, align: 'end', width: '130px',}
    ],
    paginationData: null,
    datePickerShow: false,
    filterRange: [],
    datePickerDateFormat: 'DD-MM-YYYY',
    curProject: 0,
  }),
  computed: {
    ...mapGetters({
      loading: 'ai/hrprojects/loading',
      items: 'ai/hrprojects/items',
      selected: 'ai/hrprojects/selected',
      filter: 'ai/hrprojects/filter',
      count: 'ai/hrprojects/count',
    }),
    selectedProjectStatuses: {
      get() {
        return this.filter.status;
      },
      set(val) {
        this.setFilterStatus(val);
      }
    },
  },
  methods: {
    ...mapActions({
      setSelected: 'ai/hrprojects/setSelected',
      allSelected: 'ai/hrprojects/allSelected',
      clearSelected: 'ai/hrprojects/clearSelected',
      setFilterPage: 'ai/hrprojects/setFilterPage',
      setFilterPageSize: 'ai/hrprojects/setFilterPageSize',
      setFilterName: 'ai/hrprojects/setFilterName',
      setFilterRange: 'ai/hrprojects/setFilterRange',
      setFilterComment: 'ai/hrprojects/setFilterComment',
      setFilterStatus: 'ai/hrprojects/setFilterStatus',
      setFilterAll: 'ai/hrprojects/setFilterAll',
      loadItems: 'ai/hrprojects/loadItems',
      delProject: 'ai/hrprojects/delProject',
      editProjectComment: 'ai/hrprojects/editProjectComment',
    }),
    updateOptions(param) {
      this.setFilterPageSize({ page: param.page, pageSize: param.itemsPerPage });
    },
    initialize() {
      this.setFilterAll({ params: this.$route.query });
    },
    pagination(data) {
      this.paginationData = data;
    },
    onChangeAllCheck(bool) {
      if (bool) {
        this.allSelected();
      } else {
        this.clearSelected();
      }
    },
    // eslint-disable-next-line func-names
    debouncedSetFilterName: debounce(function (val) {
      this.setFilterName(val);
    }, 500),
    // eslint-disable-next-line func-names
    debouncedSetFilterComment: debounce(function (val) {
      this.setFilterComment(val);
    }, 500),
    debouncedSendComment: debounce(function (text, item) {
      this.editDossierComment({
        id: item.id,
        text
      });
    }, 1000),
    clearFilterRange() {
      this.filterRange = [];
      this.setFilterRange(this.filterRange);
      this.datePickerShow = false;
    },
    cancelFilterRange() {
      if (this.filter.date_from && this.filter.date_to) {
        this.filterRange = [this.filter.date_from, this.filter.date_to];
      } else {
        this.filterRange = [];
      }
      this.datePickerShow = false;
    },
    applyFilterRange() {
      this.filterRange = this.filterRange.sort((a, b) =>
        this.$moment(a, this.datePickerDateFormat).isBefore(this.$moment(b, this.datePickerDateFormat)) ? -1 : 1
      );
      this.setFilterRange(this.filterRange);
      this.datePickerShow = false;
    },
    deleteProjectDialog(item) {
      this.curProject = item;
      this.showAskDeleteDialog = true;
    },
    async onDelProject(item) {
      await this.delProject(item.id)
    },

  },
  watch: {
    filter: {
      handler(val) {
        const query = {};
        for (const [key, value] of Object.entries(val)) {
          if (Array.isArray(value) && value.length) {
            query[key] = value.join(',');
          } else if (value || value === 0) {
            query[key] = value;
          }
        }
        this.$router
          .replace({ name: this.$route.name, query })
          .catch(() => {});
      },
      deep: true
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    const height = document.documentElement.clientHeight - 420;
    this.tableHeight = Math.max(height, this.tableHeight);
  }
};
</script>

<style lang="scss">
.btn-view-analysis {
  height: 27px !important;
  width: 180px;
}
</style>
